// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceCurrent_container__pOtN9","price":"PriceCurrent_price__rLH9X","originalTotalPrice":"PriceCurrent_originalTotalPrice__028XM","period":"PriceCurrent_period__ISMXQ"};